/* Amiraya back-to-top: accessible, lightweight, and safe on section reload. */
(() => {
  if (customElements.get('am-back-to-top')) return;

  class AmirayaBackToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.am-back-to-top__button');
      if (!this.button) return;
      this.threshold = Number(this.dataset.threshold) || 400;
      this.updateVisibility = this.updateVisibility.bind(this);
      this.goToTop = this.goToTop.bind(this);
      this.button.addEventListener('click', this.goToTop);
      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      this.updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateVisibility);
      this.button?.removeEventListener('click', this.goToTop);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    updateVisibility() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.classList.toggle('is-visible', window.scrollY >= this.threshold);
        this.frame = null;
      });
    }

    goToTop() {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  }

  customElements.define('am-back-to-top', AmirayaBackToTop);
})();
